export const NCPProjectExpression = [
  'id',
  'numberOS',
  'codigo',
  'estado',
  'fileNumber',
  'nameProveedor',
  'idProveedor',
  'idItinerary',
  'moneda',
  'reef',
  'saf',
  'penalidad',
  'partialPayment',
  'createdAt',
  'updatedAt',
  'idOrdenIngreso',
  'usuario',
];
